import { render, staticRenderFns } from "./txs.vue?vue&type=template&id=05280fbb&"
import script from "./txs.vue?vue&type=script&lang=js&"
export * from "./txs.vue?vue&type=script&lang=js&"
import style0 from "./txs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports